import React from 'react';

import { AccountWarehousesDataItem } from '@apis/materialsInReview/MaterialsInReview.types';
import { SearchBadge } from '@atoms/searchBadge/SearchBadge';
import { Filter, FilterProps } from '@molecules/filters/filter/Filter';
import { TreeSelect } from '@molecules/treeSelect/TreeSelect';
import { useWarehouseFilter } from '@organisms/manageInventory/MIR/shared/warehouseFilter/useWarehouseFilter';
import styles from '@organisms/manageInventory/MIR/shared/warehouseFilter/WarehouseFilter.module.less';

interface Props extends Partial<FilterProps> {
    selectedItems: string[];
    onApplyWarehouses: (value: string[]) => void;
    data: AccountWarehousesDataItem[];
}

export const WarehouseFilter = ({
    selectedItems,
    data,
    isDataLoading,
    onApplyWarehouses,
    ...props
}: Props) => {
    const {
        popupRef,
        treeData,
        selectedKeys,
        onTreeInit,
        areSelectedKeysChanged,
        handleChange,
        onRemoveSearchBadge,
        getCustomPopupContainer
    } = useWarehouseFilter({ selectedItems, data, isDataLoading });

    return (
        <Filter
            {...props}
            filterName="Warehouse"
            dataTestId="WarehouseFilter"
            isSelected={!!selectedItems.length}
            onOpenFilter={onTreeInit}
            onApply={() => onApplyWarehouses(selectedKeys)}
            isApplyDisabled={!areSelectedKeysChanged}
            mainFilterContent={
                <div ref={popupRef} className={styles.Container}>
                    <TreeSelect
                        loading={isDataLoading}
                        treeData={treeData}
                        value={selectedKeys}
                        onChange={handleChange}
                        placeholder="Warehouse"
                        className={styles.Select}
                        maxTagCount={1}
                        maxTagPlaceholder={(omittedValues) => (
                            <div className={styles.Select__Omitted}>
                                {omittedValues.length}
                            </div>
                        )}
                        tagRender={({ value }) => (
                            <SearchBadge
                                text={value}
                                key={value}
                                id={value}
                                removeBadges={onRemoveSearchBadge}
                            />
                        )}
                        dropdownClassName={styles.TreeSelectDropdown}
                        getPopupContainer={getCustomPopupContainer}
                        open
                    />
                </div>
            }
        />
    );
};
